import React, { useEffect, useState } from "react";
import "../../Styles/HorizontalBarStyle.css";
import "../../Styles/MultiPurposeStyle.css";

const API_URL = window.__API_URL__;

function PersonExperimentHistogram({ person1, person2 }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!person1 || !person2) return;

    fetch(`${API_URL}/person-experiment-histogram/${person1}/${person2}`)
      .then(res => res.json())
      .then(raw => {
        const formatted = (raw || [])
          .map(d => ({
            experiment: d.experiment,
            count: Number(d.count) || 0
          }))
          .filter(d => d.experiment)
          .sort((a, b) => b.count - a.count);

        setData(formatted);
      })
      .catch(console.error);

  }, [person1, person2]);

  if (!person1 || !person2) return null;

  const max = Math.max(...data.map(d => d.count), 1);

  return (
    <div className="card-container">

      <div className="card-header-legend">
        <h2 className="card-title">
          Cited experiments/observations
        </h2>
        <p className="card-description">
          place holder 6
        </p>
      </div>

      <div className="card-wrapper-scroll">

        {data.length === 0 ? (
          <div style={{ color: "#888", fontSize: "14px" }}>
            No data available
          </div>
        ) : (
          data.map((d, i) => (
            <div key={i} className="horizontal-bar-row">

              <div className="horizontal-bar-label">
                {d.experiment}
              </div>

              <div className="horizontal-bar-track">
                <div
                  className="horizontal-bar-fill"
                  style={{
                    width: `${(d.count / max) * 100}%`,
                    background: "#8884d8"
                  }}
                />
              </div>

              <div className="horizontal-bar-value">
                {d.count}
              </div>

            </div>
          ))
        )}

      </div>

    </div>
  );
}

export default PersonExperimentHistogram;